import { COMFORT, ER_STANDARD, STANDARD, STD } from 'constants/classOfService';
import {
  AACHEN_UIC,
  AMSTERDAM_UIC,
  ANTWERPEN_UIC,
  BRUSSEL_UIC,
  COLOGNE_UIC,
  DORTMUND_UIC,
  DUISBURG_UIC,
  DUSSELDORF_AIRPORT_UIC,
  DUSSELDORF_UIC,
  ESSEN_UIC,
  LIEGE_UIC,
  LILLE_UIC,
  ROTERDAM_UIC,
  SCHIPHOL_UIC
} from './directEurostarStations';

export const NO_MEALS_CLASS = [STD, ER_STANDARD, COMFORT, STANDARD];

export const NO_MEALS_ROUTES = new Map([
  // Blue routes
  [LILLE_UIC, new Set([BRUSSEL_UIC])],
  [BRUSSEL_UIC, new Set([LILLE_UIC, LIEGE_UIC])],

  // Red routes
  [AMSTERDAM_UIC, new Set([ROTERDAM_UIC, SCHIPHOL_UIC])],
  [ROTERDAM_UIC, new Set([ANTWERPEN_UIC, SCHIPHOL_UIC])],
  [SCHIPHOL_UIC, new Set([AMSTERDAM_UIC, ANTWERPEN_UIC])],
  [ANTWERPEN_UIC, new Set([ROTERDAM_UIC, BRUSSEL_UIC])],
  [LIEGE_UIC, new Set([BRUSSEL_UIC, AACHEN_UIC])],
  [AACHEN_UIC, new Set([COLOGNE_UIC, DORTMUND_UIC, DUISBURG_UIC, DUSSELDORF_AIRPORT_UIC, DUSSELDORF_UIC, ESSEN_UIC])],
  [COLOGNE_UIC, new Set([DORTMUND_UIC, DUISBURG_UIC, DUSSELDORF_AIRPORT_UIC, DUSSELDORF_UIC, ESSEN_UIC])],
  [DORTMUND_UIC, new Set([DUISBURG_UIC, DUSSELDORF_AIRPORT_UIC, DUSSELDORF_UIC, ESSEN_UIC])],
  [DUISBURG_UIC, new Set([DUSSELDORF_AIRPORT_UIC, DUSSELDORF_UIC, ESSEN_UIC])],
  [DUSSELDORF_AIRPORT_UIC, new Set([ESSEN_UIC])],
  [DUSSELDORF_UIC, new Set([DUSSELDORF_AIRPORT_UIC, ESSEN_UIC])],
  [ESSEN_UIC, new Set([AACHEN_UIC, COLOGNE_UIC, DORTMUND_UIC, DUISBURG_UIC, DUSSELDORF_AIRPORT_UIC, DUSSELDORF_UIC])]
]);
